<template>
    <div>
        <div class="form-row">
            <div class="col col-12 col-md-8">
                <az-periodo :sync="true" @sync="load()" v-model="filtro" />
            </div>
            <div class="col col-12 col-md-4">
                <az-input 
                    ref="pesquisa"
                    placeholder="Pesquisar..." 
                    icon="fa fa-search"
                    v-model="search"
                    @input="selecionado = 0"
					@onArrowDown="onArrowDown"
					@onArrowUp="onArrowUp"
					@onEnter="onEnter" />
            </div>
        </div>

        <div v-if="dados && dados.length">
            <div class="list-group">
                <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" 
                    :class="selecionado === iix ? 'active' : ''"
                    @click="selecionar(item)"
                    v-for="(item, iix) in dados" :key="iix">
                    <div>
                        <div>{{ item.procedimento.search }}</div>
                        <div class="small">{{ item.medico.search }}</div>
                    </div>
                    <div class="text-right">
                        <div>{{ $util.getFormatDate(item.dt_inicio) }}</div>
                        <div class="small">#{{ item.id_atendimento }}</div>
                        
                    </div>
                </button>
            </div>

            <pre v-if="false">{{ dados }}</pre>
        </div>

        <div v-else-if="ja_buscou">
            <div class="list-group">
                <button type="button" class="list-group-item list-group-item-action">
                    Nenhum atendimento encontrado.
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import AzPeriodo from './forms/AzPeriodo.vue';
import AzInput from './forms/AzInput.vue';

export default {
    data() { 
        return { 
            filtro: { 
                periodo: "m",
            },
            search: "", 
            ja_buscou: false, 
            dados: null, 
            selecionado: 0, 
        };
    },

    props: ['id_paciente'],

    components: { 
        AzPeriodo, 
        AzInput, 
    },

    methods: { 
        onArrowDown () { 
			this.selecionado ++;
		},

		onArrowUp () { 
			if ( this.selecionado > 0 ) { 
				this.selecionado --;
			}			
		},

		onEnter () { 
            if ( this.dados[this.selecionado] ) { 
                this.selecionar(this.dados[this.selecionado]);
            }
        },

        selecionar(item) { 
            let origem = {};

            if ( item.doc_pre_atends ) { 
                item.doc_pre_atends.forEach(doc => { 
                    if ( doc.js_conteudo ) { 
                        let campos = this.$utilform.obter_campos(doc.js_conteudo);
                        origem = _.merge(origem, campos);
                    }
                });
            }

            if ( item.atendimento && item.atendimento.atendimento_procedimentos ) { 
                item.atendimento.atendimento_procedimentos.filter(atp => atp.anamnese && atp.anamnese.dados)
                    .forEach(atp => { 
                        let campos = this.$utilform.obter_campos(atp.anamnese.dados);
                        origem = _.merge(origem, campos);
                    });
            }

            this.$emit('selecionado', origem);
        },

        exibir() { 
            if ( !this.ja_buscou ) { 
                this.load();
            }

            this.$nextTick(() => { 
                this.$refs['pesquisa'].$refs.input.focus ();
            });
        },

        load() { 
            this.selecionado = 0;

            this.$util.load(this, { 
                service: 'marcacoes',
                func: 'index',
                parms: { 
                    id_paciente: this.id_paciente, 
                    buscar_herdar: true, 
                    ...this.filtro, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        }
    }
}
</script>